import loadable from '@loadable/component';

// 懒加载组件
const HosItemQuery = loadable(() => import('./hosItemQuery/HosItemQuery'));
const ItemNewManagement = loadable(() => import('./itemNewManagement/ItemNewManagement'));
const HosItemPriceQuery = loadable(() => import('./hosItemPriceQuery/HosItemPriceQuery'));
const ItemPriceRequestManagement = loadable(() => import('./itemPriceRequestManagement/ItemPriceRequestManagement'));
const ItemPriceRequestDetailModify = loadable(() => import('./itemPriceRequestManagement/itemPriceRequestDetailModify/ItemPriceRequestDetailModify'));

export default [
  {
    path: '/HosItemQuery',
    component: HosItemQuery
  },
  {
    path: '/ItemNewManagement',
    component: ItemNewManagement
  },
  {
    path: '/HosItemPriceQuery',
    component: HosItemPriceQuery
  },
  {
    path: '/ItemPriceRequestManagement',
    component: ItemPriceRequestManagement
  },
  {
    path: '/ItemPriceRequestDetailModify',
    component: ItemPriceRequestDetailModify
  }
];
